<mat-card class="start-trial-banner" *ngIf="showStartTrialBanner()">
  <mat-card-content>
    <div class="row row-gutters">
      <div class="col col-xs-12 col-sm-2 image">
        <img
          src="https://vstatic-prod.apigateway.co/partner-center-client.9223372035099833042.prod/assets/images/start-trial-banner/grow-your-revenue.png"
        />
      </div>
      <div class="col">
        <mat-card-title>
          {{ 'START_TRIAL_BANNER.HEADING' | translate: { numDays: numDaysTrial() } }}
        </mat-card-title>
        <p>{{ 'START_TRIAL_BANNER.DESCRIPTION' | translate: { numDays: numDaysTrial() } }}</p>
        <button (click)="startTrial()" mat-flat-button color="primary">
          {{ 'START_TRIAL_BANNER.START_FREE_TRIAL_BUTTON' | translate }}
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
